<ion-header [translucent]="true">

    <ion-toolbar class="ion-padding-end">
        <ion-title slot="start">Selecionar Consumidores</ion-title>
        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </ion-toolbar>

    <ion-toolbar>
        <ion-grid class="ion-no-padding">
            <ion-row>
                <ion-col>
                    <ion-searchbar placeholder="pesquisar por nome ou NIF"
                        (ionInput)="OnSearch($event?.detail?.value)"
                        (ionClear)="OnSearch('')">
                    </ion-searchbar>
                </ion-col>
                <ion-col size="auto" class="display-flex ion-justify-content-end ion-align-items-center">
                    <ion-button (click)="OnSave($event)">
                        Guardar
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-toolbar>

</ion-header>

<ion-content class="ion-padding" [fullscreen]="true">

    <ion-grid class="ion-no-padding table">

        <ion-row class="table-header">
            <ion-col class="icon-status-size-2">
                <ion-checkbox class="ion-margin-start"
                    *ngIf="FilteredData?.length > 0"
                    [checked]="AllChecked"
                    [disabled]="!!SearchText"
                    (click)="OnChangeValue($event, null, true)">
                </ion-checkbox>
            </ion-col>
            <ion-col style="padding-left: 16px !important;">Nome</ion-col>
            <ion-col size="3" class="ion-hide-sm-down">NIF</ion-col>
        </ion-row>

        <ion-row class="table-body ion-padding-horizontal" *ngFor="let item of FilteredData">
            <ion-col class="icon-status-size-2">
                <ion-item class="ion-no-margin">
                    <ion-checkbox [checked]="item?.Checked"
                        (ionChange)="OnChangeValue($event, item)">
                    </ion-checkbox>
                </ion-item>
            </ion-col>
            <ion-col>{{item?.Name || '--'}}</ion-col>
            <ion-col size="3" class="ion-hide-sm-down">{{item?.VatNumber || '--'}}</ion-col>
        </ion-row>

        <no-items *ngIf="FilteredData?.length == 0" description="Sem resultados"></no-items>

    </ion-grid>

</ion-content>
